import {
  Component,
  OnInit,
} from '@angular/core';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { AuctionService, LaunchDarklyService } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';


@Component({
    selector: 'app-make-active-modal',
    templateUrl: './make-active-modal.component.html',
    styleUrls: ['./make-active-modal.component.scss'],
    imports: [TranslocoDirective]
})
export class MakeActiveModalComponent extends ChangeStatusModalDirective implements OnInit {
  textActivateVehicles: string;
  textActiveVehicle: string;
  textAuctionVehicles: string;
  textAuctionVehicle: string;

  constructor(store: Store, auctionService: AuctionService, readonly launchDarklyService: LaunchDarklyService, readonly translocoService: TranslocoService) {
    super(store, auctionService, launchDarklyService, translocoService);
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textActivateVehicles;
    } else {
      return this.textActiveVehicle;
    }
  }

  get modalBody() {
    if (this.selectedVehicles.length > 1) {
      return this.textAuctionVehicles;
    } else {
      return this.textAuctionVehicle;
    }
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.makeActiveModal')
      .subscribe(translate => {
        this.textActivateVehicles = translate.textActivateVehicles;
        this.textActiveVehicle = translate.textActiveVehicle;
        this.textAuctionVehicles = translate.textAuctionVehicles;
        this.textAuctionVehicle = translate.textAuctionVehicle;
      });
  }
}
